import styled from "styled-components";
import Login from "../Components/Login";
import Register from "../Components/Register";
import Section from "../Atoms/Section";
import H1 from "../Atoms/H1";
import { useTranslation } from "react-i18next";
import BoldBlue from "../Atoms/BoldBlue";
import BigH1 from "../Atoms/BigH1";

const Container = styled.div`
    background-color: white;
`;

/*

L’adhésion à la communauté Le FRENCH DESIGN vous donne accès à des services
exclusifs

• Présentation de votre profil, société, et projets dans notre annuaire rassemblant les
membres de notre communauté
• Accès exclusif à notre annuaire comprenant les contacts, les sociétés et les portfolios de
la communauté
• Valorisation de vos projets à travers une communication dédiée sur nos réseaux
• Accès à des ressources documentaires sectorielles à tarif réduit
• Accès prioritaire à nos programmes et évènements avec un tarif réduit

Tarifs et conditions

Adhésion valable 1 an à partir de la date d’achat
Montant de l’adhésion : 35€ TTC

*/

const LoginRegisterIframe = (props) => {

    const { i18n } = useTranslation('common');

    //get url params
    const urlParams = new URLSearchParams(window.location.search);
    const thengotoevent = urlParams.get("thengotoevent") || false;

    return (
        <Container>
            <Section className="padding">
                <BigH1>CONNECTED BY<br/>Le FRENCH DESIGN</BigH1><br/>
                <BoldBlue style={{fontSize:"50px"}}>{i18n.language === "fr" ? "Intégrez notre communauté" : "Join our community"}</BoldBlue><br/><br/>
            </Section>
            <Section className="flexblock">
                <Login refreshUser={props.refreshUser} thengotoevent={thengotoevent}/>
                <Register/>
            </Section>
            <Section className="padding">
                <BoldBlue>{i18n.language === "fr" ? "L’adhésion à la communauté Le FRENCH DESIGN vous donne accès à des services exclusifs" : "Membership in the Le FRENCH DESIGN community gives you access to exclusive services"}</BoldBlue><br/><br/>
                <span>• {i18n.language === "fr" ? "Présentation de votre profil, société, et projets dans notre annuaire rassemblant les membres de notre communauté" : "Presentation of your profile, company, and projects in our directory bringing together the members of our community"}</span><br/>
                <span>• {i18n.language === "fr" ? "Accès exclusif à notre annuaire comprenant les contacts, les sociétés et les portfolios de la communauté" : "Exclusive access to our directory including contacts, companies and portfolios of the community"}</span><br/>
                <span>• {i18n.language === "fr" ? "Valorisation de vos projets à travers une communication dédiée sur nos réseaux" : "Promotion of your projects through dedicated communication on our networks"}</span><br/>
                <span>• {i18n.language === "fr" ? "Accès à des ressources documentaires sectorielles à tarif réduit" : "Access to sectoral documentary resources at a reduced rate"}</span><br/>
                <span>• {i18n.language === "fr" ? "Accès prioritaire à nos programmes et évènements avec un tarif réduit" : "Priority access to our programs and events at a reduced rate"}</span><br/>
                <br/><br/>
                <BoldBlue>{i18n.language === "fr" ? "Tarifs et conditions" : "Rates and conditions"}</BoldBlue><br/><br/>
                <span>{i18n.language === "fr" ? "Adhésion valable 1 an à partir de la date d’achat" : "Membership valid for 1 year from the date of purchase"}</span><br/>
                <strong>{i18n.language === "fr" ? "Montant de l’adhésion : 35€ TTC" : "Membership amount: 35 € including VAT"}</strong><br/><br/>
            </Section>
        </Container>
    );
};

export default LoginRegisterIframe;